const commaSeparator = (input) => Number(input).toLocaleString()
// 3 Number Separator
// const separator = x => x + "".replace(/\B(?=(\d{3})+(?!\d))/g, ",")

export default commaSeparator;